import React, { useState } from "react";
import SmWrapper from "../../Components/SmWrapper";
import Heading from "../../tailwindUI/Heading";
import ErrorMessage from "../../tailwindUI/ErrorMessage";

const ClickToBuy = () => {
  const [journalVoucher, setJournalVoucher] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleFetch = async () => {
    if (!journalVoucher.trim()) {
      setError("Please enter a Journal Voucher");
      return;
    }

    setLoading(true);
    setError("");
    setData(null);

    try {
      const userToken = process.env.REACT_APP_WINGS_TOKEN;
      const authToken = process.env.REACT_APP_AUTH_TOKEN;
      const baseUrl = process.env.REACT_APP_API_BASE_URL;

      if (!userToken || !authToken || !baseUrl) {
        throw new Error("Missing environment configuration");
      }

      const formData = new FormData();
      formData.append("UserToken", userToken);
      formData.append("JournalVoucher", journalVoucher);

      const response = await fetch(
        `${baseUrl}/api/v1/stockone/srm/GetWingsClickToBuyBookingDetail`,
        {
          method: "POST",
          headers: {
            Authorization: authToken,
          },
          body: formData,
        }
      );

      const responseData = await response.json();

      if (!response.ok || responseData?.status_code !== 200) {
        throw new Error(responseData?.message || "API returned an error");
      }

      setData(responseData);
    } catch (err) {
      console.error("ClickToBuy API error:", err);
      setError(
        err && err.message ? err.message : "Failed to fetch booking details"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setData(null);
    setJournalVoucher("");
    setError("");
  };

  return (
    <SmWrapper>
      <Heading
        headingType={"Page Headings small"}
        headingText={"Click to Buy Booking Detail"}
        BreadCrumHomeLink={"/sm-dashboard"}
        subheadingText={localStorage.getItem("Location")}
      />

      <div className="flex justify-center items-center min-h-[60vh] bg-transparent">
        <div className="bg-white shadow-2xl rounded-3xl p-10 w-full max-w-5xl border border-gray-100 transition-all duration-300 flex flex-col">
          {!data && (
            <>
              <div className="mb-8 w-full text-center">
                <Heading
                  headingType={"sub heading small"}
                  headingText={"Enter Journal Voucher to Fetch Booking"}
                />
              </div>

              <form
                className="w-full flex flex-col items-center"
                onSubmit={(e) => {
                  e.preventDefault();
                  handleFetch();
                }}
                autoComplete="off"
              >
                <div className="w-full flex flex-col items-center gap-2">
                  <label className="block text-base font-medium text-gray-700 mb-1 text-center w-full">
                    Journal Voucher *
                  </label>

                  <div className="flex w-full justify-center gap-4">
                    <input
                      type="text"
                      value={journalVoucher}
                      onChange={(e) => setJournalVoucher(e.target.value)}
                      className="w-72 text-lg rounded-xl px-4 py-3 border-2 border-gray-200 focus:border-blue-400 focus:ring-2 focus:ring-blue-100 transition-all duration-200 outline-none"
                      placeholder="Enter Journal Voucher (e.g. JEO/S/26/ 2848)"
                      disabled={loading}
                    />

                    <button
                      type="submit"
                      disabled={loading || !journalVoucher.trim()}
                      className="text-lg rounded-xl px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold transition-all duration-200 shadow-md focus:outline-none focus:ring-2 focus:ring-blue-300 disabled:opacity-60"
                    >
                      {loading ? "Loading..." : "Fetch Details"}
                    </button>
                  </div>
                </div>
              </form>

              {error && (
                <div className="mt-6 w-full">
                  <ErrorMessage message={error} />
                </div>
              )}
            </>
          )}

          {data?.data && (
            <div className="w-full">
                <div className="flex items-center justify-between mb-6">
                <Heading headingType={"sub heading small"} headingText={"Booking Receipt"} />
                <button
                    onClick={handleCancel}
                    className="text-sm font-semibold text-red-600 hover:underline"
                >
                    Cancel / Back
                </button>
                </div>

                {/* Customer Details */}
                <div className="mb-8">
                <h3 className="text-base font-bold mb-4">Customer Details</h3>

                <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-6">

                    <div className="md:col-span-1">
                    <label>First Name</label>
                    <input value={data.data.CustomerFirstName || ""} readOnly className="form-input" />
                    </div>

                    <div className="md:col-span-1">
                    <label>Last Name</label>
                    <input value={data.data.CustomerLastName || ""} readOnly className="form-input" />
                    </div>

                    <div className="md:col-span-1">
                    <label>Mobile Number</label>
                    <input value={data.data.CustomerMobile || ""} readOnly className="form-input" />
                    </div>

                    <div className="md:col-span-1">
                    <label>Booking Amount</label>
                    <input value={data.data.Amount || ""} readOnly className="form-input" />
                    </div>

                    <div className="md:col-span-1">
                    <label>ASM</label>
                    <input value={data.data.AsmName || ""} readOnly className="form-input" />
                    </div>

                    <div className="md:col-span-1">
                    <label>Executive</label>
                    <input value={data.data.ExecutiveName || ""} readOnly className="form-input" />
                    </div>

                    <div className="md:col-span-1">
                    <label>Date of Booking</label>
                    <input value={data.data.Date || ""} readOnly className="form-input" />
                    </div>

                    <div className="md:col-span-1">
                    <label>Committed Delivery Date</label>
                    <input value={"-"} readOnly className="form-input" />
                    </div>

                    <div className="md:col-span-1">
                    <label>WINGS ID</label>
                    <input value={data.data.transactionNo || ""} readOnly className="form-input" />
                    </div>

                    <div className="md:col-span-1">
                    <label>Booking Priority</label>
                    <input value={"-"} readOnly className="form-input" />
                    </div>

                    <div className="md:col-span-1">
                    <label>Receipt No</label>
                    <input value={data.data.JournalEntryNumber || ""} readOnly className="form-input" />
                    </div>

                    <div className="md:col-span-1">
                    <label>Upload Receipt</label>
                    <input value={"Receipt"} readOnly className="form-input" />
                    </div>
                </div>
                </div>

                {/* Vehicle Preference */}
                <div className="mb-8">
                <h3 className="text-base font-bold mb-4">Vehicle Preference</h3>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <input value={"-"} readOnly className="form-input" placeholder="Model" />
                    <input value={"-"} readOnly className="form-input" placeholder="Variant" />
                    <input value={"-"} readOnly className="form-input" placeholder="Color" />
                </div>
                </div>

                {/* Other Details */}
                <div>
                <h3 className="text-base font-bold mb-4">Other Details</h3>

                <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
                    <input value={"-"} readOnly className="form-input" placeholder="YOM" />
                    <input value={"No"} readOnly className="form-input" placeholder="Exchange" />
                    <input value={data.data.Amount || ""} readOnly className="form-input" placeholder="Final Deal Amount" />
                    <input value={"-"} readOnly className="form-input" placeholder="Payment Method" />
                    <input value={"No"} readOnly className="form-input" placeholder="Loan Approved" />
                </div>
                </div>
            </div>
            )}

        </div>
      </div>
    </SmWrapper>
  );
};

export default ClickToBuy;
